import { render, staticRenderFns } from "./CreateModal.vue?vue&type=template&id=37dbc49b&scoped=true"
import script from "./CreateModal.vue?vue&type=script&lang=js"
export * from "./CreateModal.vue?vue&type=script&lang=js"
import style0 from "./CreateModal.vue?vue&type=style&index=0&id=37dbc49b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dbc49b",
  null
  
)

export default component.exports